import { registerIconLibrary } from "@awesome.me/webawesome-pro/dist/webawesome.js";
import { icon, library } from "@fortawesome/fontawesome-svg-core";

// Duotone Light icons (variant="light")
import {
	faHome,
	faNewspaper,
	faBriefcase,
	faEnvelope,
	faArrowRight,
	faArrowLeft,
	faCalendar,
	faClock,
	faSunBright,
	faMoonStars,
	faCompass,
	faRss,
	faXmark,
	faCopy,
	faCheck,
	faBars,
	faCircleInfo,
	faLightbulb,
	faCircleExclamation,
	faTriangleExclamation,
	faOctagonExclamation,
	faBridge,
	faWebAwesome,
	faFontAwesome as faFontAwesomeDuotone,
	faBookOpen,
	faArrowsRotate,
	faReply,
	faRetweet,
	faStar,
	faFolderOpen,
	faMagnifyingGlass,
	faFingerprint,
	faTerminal,
	faShieldKeyhole,
	faKey,
	faDatabase,
	faClipboard,
	faDownload,
	faCodeBranch,
	faLock,
	faBolt,
	faGear,
	faKeyboard,
	faGem,
	faBracketsCurly,
	faDiagramProject,
	faTimeline,
	faCheckDouble,
	faFileCode,
	faRightLeft,
	faPuzzlePiece,
	faFlask,
} from "@fortawesome/duotone-light-svg-icons";

// Brand icons
import {
	faMastodon,
	faBluesky,
	faGithub,
	faLinkedin,
	faApple,
	faSwift,
} from "@fortawesome/free-brands-svg-icons";

// Add icons to Font Awesome library
library.add(
	faHome,
	faNewspaper,
	faBriefcase,
	faEnvelope,
	faArrowRight,
	faArrowLeft,
	faCalendar,
	faClock,
	faSunBright,
	faMoonStars,
	faCompass,
	faRss,
	faXmark,
	faCopy,
	faCheck,
	faBars,
	faCircleInfo,
	faLightbulb,
	faCircleExclamation,
	faTriangleExclamation,
	faOctagonExclamation,
	faMastodon,
	faBluesky,
	faGithub,
	faLinkedin,
	faBridge,
	faWebAwesome,
	faFontAwesomeDuotone,
	faBookOpen,
	faArrowsRotate,
	faReply,
	faRetweet,
	faStar,
	faFolderOpen,
	faMagnifyingGlass,
	faFingerprint,
	faTerminal,
	faShieldKeyhole,
	faKey,
	faDatabase,
	faClipboard,
	faDownload,
	faCodeBranch,
	faLock,
	faBolt,
	faGear,
	faKeyboard,
	faGem,
	faBracketsCurly,
	faDiagramProject,
	faTimeline,
	faCheckDouble,
	faFileCode,
	faRightLeft,
	faPuzzlePiece,
	faFlask,
	faApple,
	faSwift,
);

// Icon maps by family
const duotoneIcons = {
	home: faHome,
	newspaper: faNewspaper,
	briefcase: faBriefcase,
	envelope: faEnvelope,
	"arrow-right": faArrowRight,
	"arrow-left": faArrowLeft,
	calendar: faCalendar,
	clock: faClock,
	"sun-bright": faSunBright,
	"moon-stars": faMoonStars,
	compass: faCompass,
	rss: faRss,
	xmark: faXmark,
	copy: faCopy,
	check: faCheck,
	bars: faBars,
	"circle-info": faCircleInfo,
	lightbulb: faLightbulb,
	"circle-exclamation": faCircleExclamation,
	"triangle-exclamation": faTriangleExclamation,
	"octagon-exclamation": faOctagonExclamation,
	bridge: faBridge,
	"web-awesome": faWebAwesome,
	"font-awesome": faFontAwesomeDuotone,
	"book-open": faBookOpen,
	"arrows-rotate": faArrowsRotate,
	reply: faReply,
	retweet: faRetweet,
	star: faStar,
	"folder-open": faFolderOpen,
	"magnifying-glass": faMagnifyingGlass,
	fingerprint: faFingerprint,
	terminal: faTerminal,
	"shield-keyhole": faShieldKeyhole,
	key: faKey,
	database: faDatabase,
	clipboard: faClipboard,
	download: faDownload,
	"code-branch": faCodeBranch,
	lock: faLock,
	bolt: faBolt,
	gear: faGear,
	keyboard: faKeyboard,
	gem: faGem,
	"brackets-curly": faBracketsCurly,
	"diagram-project": faDiagramProject,
	timeline: faTimeline,
	"check-double": faCheckDouble,
	"file-code": faFileCode,
	"right-left": faRightLeft,
	"puzzle-piece": faPuzzlePiece,
	flask: faFlask,
};

const brandIcons = {
	mastodon: faMastodon,
	bluesky: faBluesky,
	github: faGithub,
	linkedin: faLinkedin,
	apple: faApple,
	swift: faSwift,
};

// Icon resolver function
const resolver = (name, family, _variant) => {
	let iconDef;

	if (family === "brands") {
		iconDef = brandIcons[name];
	} else {
		iconDef = duotoneIcons[name];
	}

	if (iconDef) {
		// Use Font Awesome's icon() function to generate proper SVG
		const renderedIcon = icon(iconDef);
		let svg = renderedIcon.html[0];

		// Add opacity to secondary path (FA CSS normally handles this, but we're not loading it)
		svg = svg.replace(
			'class="fa-secondary"',
			'class="fa-secondary" opacity="0.4"',
		);

		return `data:image/svg+xml,${encodeURIComponent(svg)}`;
	}

	console.warn(`Icon not found: ${name} (family: ${family})`);
	return "";
};

// Register for both default and system libraries
// (system is used internally by Web Awesome components like wa-page)
registerIconLibrary("default", { resolver });
registerIconLibrary("system", { resolver });
